<template>
  <div>
    <a-row>
      <a-col
        :span="24"
        :lg="24"
        :xl="24"
        class="mb-24"
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <a-radio-group
          v-model:value="dateType"
          button-style="solid"
          @change="dateTypeChange"
          size="small"
        >
          <a-radio-button value="1">周</a-radio-button>
          <a-radio-button value="2">月</a-radio-button>
          <a-radio-button value="3">年</a-radio-button>
          <a-radio-button value="4">全部</a-radio-button>
        </a-radio-group>
      </a-col>
    </a-row>

    <div class="my-charts" ref="myChart"></div>
  </div>
</template>

<script>
import { WCIOptions, WCITKOptions } from "./KeywordPieChartOpt";
export default {
  data() {
    return {
      dateType: "1",
      chart: null,
      keyword: "",
      wciChartData: [],
      tkChartData: [],
      wciSeriesData: [
        { value: 0, name: "WCI广告" },
        { value: 0, name: "WCI外链" },
        { value: 0, name: "WCI直播" },
        { value: 0, name: "WCI公众号" },
        { value: 0, name: "WCI搜一搜" },
        { value: 0, name: "WCI问一问" },
        { value: 0, name: "WCI视频号" },
      ],
      tkSeriesData: [
        { value: 0, name: "TK搜索" },
        { value: 0, name: "TK综合" },
      ],
      ChartGrid: [],
      ChartLegend: [],
      ChartSeries: [],
    };
  },
  methods: {
    SetData(wciData, tkData) {
      this.wciChartData = wciData;
      this.tkChartData = tkData;
      this.GetDate();
    },
    GetDate() {
      this.ChartSeries = [];
      var WciChartData = [];
      if (this.dateType == "1") {
        WciChartData = this.wciChartData.slice(
          this.wciChartData.length - 7,
          this.wciChartData.length
        );
      } else if (this.dateType == "2") {
        WciChartData = this.wciChartData.slice(
          this.wciChartData.length - 30,
          this.wciChartData.length
        );
      } else if (this.dateType == "3") {
        WciChartData = this.wciChartData.slice(
          this.wciChartData.length - 365,
          this.wciChartData.length
        );
      } else {
        WciChartData = this.wciChartData;
      }
      this.wciSeriesData[0].value = WciChartData.reduce((total, item) => {
        // 确保 item.adScore 是数字类型
        return total + (Number(item.adScore) || 0);
      }, 0);
      this.wciSeriesData[1].value = WciChartData.reduce((total, item) => {
        // 确保 item.adScore 是数字类型
        return total + (Number(item.extlinkScore) || 0);
      }, 0);
      this.wciSeriesData[2].value = WciChartData.reduce((total, item) => {
        // 确保 item.adScore 是数字类型
        return total + (Number(item.liveScore) || 0);
      }, 0);
      this.wciSeriesData[3].value = WciChartData.reduce((total, item) => {
        // 确保 item.adScore 是数字类型
        return total + (Number(item.mpdocScore) || 0);
      }, 0);
      this.wciSeriesData[4].value = WciChartData.reduce((total, item) => {
        // 确保 item.adScore 是数字类型
        return total + (Number(item.queryScore) || 0);
      }, 0);
      this.wciSeriesData[5].value = WciChartData.reduce((total, item) => {
        return total + (Number(item.w1wScore) || 0);
      }, 0);
      this.wciSeriesData[6].value = WciChartData.reduce((total, item) => {
        return total + (Number(item.finderScore) || 0);
      }, 0);
      this.keyword = this.wciChartData[0].keyWord;
      this.ChartGrid = WCIOptions.Grid;
      this.ChartLegend = WCIOptions.Legend;
      this.ChartSeries.push({
        name: "WCI - " + this.keyword,
        type: "pie",
        radius: "50%",
        data: this.wciSeriesData,
        center: ["50%", "50%"],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      });

      if (this.tkChartData.length > 0) {
        var TkChartData = [];
        if (this.dateType == "1") {
          TkChartData = this.tkChartData.slice(
            this.tkChartData.length - 7,
            this.tkChartData.length
          );
        } else if (this.dateType == "2") {
          TkChartData = this.tkChartData.slice(
            this.tkChartData.length - 30,
            this.tkChartData.length
          );
        } else if (this.dateType == "3") {
          TkChartData = this.tkChartData.slice(
            this.tkChartData.length - 365,
            this.tkChartData.length
          );
        } else {
          TkChartData = this.tkChartData;
        }

        this.tkSeriesData[0].value = TkChartData.reduce((total, item) => {
          // 确保 item.adScore 是数字类型
          return total + (Number(item.searchScore) || 0);
        }, 0);
        this.tkSeriesData[1].value = TkChartData.reduce((total, item) => {
          // 确保 item.adScore 是数字类型
          return total + (Number(item.topScore) || 0);
        }, 0);

        this.ChartGrid = WCITKOptions.Grid;
        this.ChartLegend = WCITKOptions.Legend;

        this.ChartSeries[0].center = ["50%","25%"]
        this.ChartSeries.push({
          name: "TK - " + this.keyword,
          type: "pie",
          radius: "50%",
          center: ["50%", "75%"],
          data: this.tkSeriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        });
      }

      this.InitOptions();
    },
    dateTypeChange() {
      this.GetDate();
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    InitOptions() {
      this.chart = this.$echarts.init(this.$refs.myChart);
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        grid: this.ChartGrid,
        legend: this.ChartLegend,
        series: this.ChartSeries,
      });
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.my-charts {
  width: 100%; // 设置宽度为100%，使其适应父容器
  height: 40vh; // 设置固定高度，可根据需要调整
}
</style>